module.exports = __webpack_public_path__ + "static/media/logo-dpos.c3be3027.png";